import {Box, Card, Grid, Heading} from '@primer/react-brand/esm'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import type {Document} from '@contentful/rich-text-types'
import type {IconLinkItem} from '../../types'
import {renderWithoutParagraphs} from '../../utils'
import baseStyles from '../../styles/base.module.css'

export type FlexSuiteIconCardsProps = {
  heading?: Document
  cards?: IconLinkItem[]
}

export function FlexSuiteIconCards({heading, cards}: FlexSuiteIconCardsProps) {
  if (!cards?.length) return null

  return (
    <>
      {heading && (
        <Box paddingBlockEnd={{narrow: 'spacious', regular: 64}} paddingBlockStart={{narrow: 'spacious', regular: 64}}>
          <Grid>
            <Grid.Column span={12}>
              <Heading as="h3" style={{textAlign: 'center'}}>
                {renderWithoutParagraphs(heading)}
              </Heading>
            </Grid.Column>
          </Grid>
        </Box>
      )}
      <Box className={`${baseStyles.cardGridFrame} ${baseStyles.gridFrameTop}`}>
        <Grid className={baseStyles.gridContent} columnGap="none">
          {cards.map(cardItem => {
            const id = cardItem.sys.id
            const card = cardItem.fields
            const IconComponent = getPrimerIcon(card.icon)

            return (
              /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
              <Grid.Column span={{small: 12, medium: 4}} key={id} className="gridColumn">
                <Box
                  className={baseStyles.cardGridItem}
                  padding={{narrow: 24, regular: 40}}
                  paddingBlockStart={{regular: 80}}
                  paddingBlockEnd={{regular: 80}}
                  borderWidth="thin"
                  borderColor="muted"
                >
                  <Card href={card.href} variant="minimal" fullWidth ctaVariant="arrow" ctaText={card.label}>
                    {IconComponent ? <Card.Icon icon={<IconComponent />} color="default" hasBackground /> : null}
                    {card.eyebrow ? <Card.Label>{card.eyebrow}</Card.Label> : null}
                    <Card.Heading>{renderWithoutParagraphs(card.heading)}</Card.Heading>
                    <Card.Description>{renderWithoutParagraphs(card.description)}</Card.Description>
                  </Card>
                </Box>
              </Grid.Column>
            )
          })}
        </Grid>
      </Box>
    </>
  )
}
